import React from 'react';
import { TOOLBAR_BUTTON, TOOLBAR_BUTTON_DISABLED } from './toolbarButtonStyle';

type Props = {
	// The text of the button. Change it while the action runs ("Preparing…"): the button has no spinner.
	children: React.ReactNode,
	// An icon before the text: give it the size only (h-4 w-4). The button sets its colour, gray-400 like the icons of
	// CheckboxMenu, gray-300 when disabled, and hides it from a screen reader.
	icon?: React.ReactNode,
	onClick?: () => void,
	disabled?: boolean,
	// The name for a screen reader when the text alone does not say what the button does.
	ariaLabel?: string,
	title?: string,
};

// The white toolbar button of a card header: one action, 36 px high, a gray ring. It has the look of CheckboxMenu
// variant 'button' and of the MonthRangePicker button, so a row of these controls has one height. FormButton (38 px,
// slate colours) is for forms and page headers; this button is for the controls beside a menu button.
const ToolbarButton: React.FunctionComponent<Props> = ({ children, icon, onClick, disabled = false, ariaLabel, title }) =>
	<button type="button" onClick={onClick} disabled={disabled} aria-label={ariaLabel} title={title}
		className={disabled ? TOOLBAR_BUTTON_DISABLED : TOOLBAR_BUTTON}>
		{icon !== undefined && <span aria-hidden="true" className={disabled ? 'text-gray-300' : 'text-gray-400'}>{icon}</span>}
		{children}
	</button>;

export default ToolbarButton;
